import { BaseSendMessageModel } from "./MessageModel";

export interface Book {
    Id: number;
    Title: string;
    CoverId: string;
    Description: string;
    Price1: number;
    Price2: number;
    Author: string;
    CreatedByUserId: string;
    DateCreatedUtc: string;
    IsFeatured: boolean;
    DiscountPercentage: number;
    DiscountedPrice: number;
    DiscountStartDateUtc: string;
    DiscountEndDateUtc: string;
}

export class CreateBookModel extends BaseSendMessageModel {
    title: string;
    coverId: string;
    description: string;
    price1: number;
    price2: number;
    author: string;
    isFeatured: boolean;
    discountPercentage: number;
    discountStartDateUtc: Date;
    discountEndDateUtc: Date;
}

export class EditBookModel extends CreateBookModel { 
    id: number;
    constructor(item?: Book) {
        super();
        this.id = item.Id;
        this.title = item.Title;
        this.coverId = item.CoverId;
        this.description = item.Description;
        this.price1 = item.Price1;
        this.price2 = item.Price2;
        this.author = item.Author;
        this.isFeatured = item.IsFeatured;
        this.discountPercentage = item.DiscountPercentage;
        this.discountStartDateUtc = item && new Date(item.DiscountStartDateUtc + "Z");
        this.discountEndDateUtc = item && new Date(item.DiscountEndDateUtc + "Z");
    }
}


// WEBPACK FOOTER //
// ./src/app/models/inModels/Book.ts